<template>
	<div class="content-edit-listing-mobile">
		<b-container fluid="xl">
			<h4 class="title">
				{{
					firstStep
						? $t('addListing.details.details')
						: secondStep
						? $t('addListing.preview.preview')
						: $t('addListing.neat.neat')
				}}
			</h4>
			<div class="steper-add-listing">
				<div class="divider"></div>
				<div class="stepper-circle">
					<div class="circle-title" v-bind:class="{ selected: firstStep }">
						<div class="circle">
							<PencilIcon />
						</div>
					</div>
					<!-- <div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<MagnifyIcon />
						</div>
					</div> -->
					<div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<CheckIcon />
						</div>
					</div>
				</div>
			</div>
			<template v-if="firstStep">
				<b-form class="form-add-listing">
					<b-row>
						<!-- Main category -->
						<b-col cols="12">
							<b-form-group
								:label="$t('addListing.details.selectProductCategory')"
							>
								<b-button
									class="btn-category"
									id="mainCategory"
									@click="
										isActiveCategory = !isActiveCategory;
									"
								>
									{{ listing.mainCategory ? $t(listing.mainCategory.name) : '' }}
									<IconChevronDown />
								</b-button>
							</b-form-group>
						</b-col>
						<!-- Sub category -->
						<b-col cols="12">
							<b-form-group :label="$t('Select a subcategory')">
								<b-button
									class="btn-category"
									id="childCategory"
									@click="isActiveCateChild = !isActiveCateChild"
								>
									{{
										listing.subCategory
											? $t(listing.subCategory.name)
											: $t('addListing.details.selectSubCategory')
									}}
									<IconChevronDown />
								</b-button>
							</b-form-group>
						</b-col>
						<!-- Product name -->
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_title)">
								<b-form-input
									v-model="listing.title"
									:placeholder="$t(childCategories.field_name_title)"
									:class="{
										'input-error': validateErrors ? validateErrors.title : false
									}"
								></b-form-input>
							</b-form-group>
						</b-col>
						<!-- Attributes -->
						<template
							v-for="(item, key) in childCategories.category_attribute_details"
						>
							<b-col
								:key="key"
								cols="12"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Radio button'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<span v-if="item.id==1||item.id==135" style="position: absolute;right: 100px;">
									<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor) !important;"/>
									<b-tooltip
										custom-class="website-tool-tips"
										placement="righttop"
										target="price-info"
									>
										{{$t('rentOrSaleNote', selectedLangugae)}}
									</b-tooltip>
								</span>
									<b-form-radio-group
										:name="`radio-sub-component-${key + 1}`"
										class="group-radio"
										v-model="
											listing.listingAttr.data[`radioValue_${item.attr_id}`]
										"
										@change="
										changeRadioValue($event, `radioValue_${item.attr_id}`)
									"
									>
										<b-form-radio
											:value="value.id"
											v-for="(value, key) in item.listing_attribute
												.listing_pre_values"
											:key="key"
											>{{ $t(value.value) }}</b-form-radio
										>
									</b-form-radio-group>
								</b-form-group>
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Textbox'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										<b-form-input
											:placeholder="$t(item.listing_attribute.name)"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
										></b-form-input>
										<template
											v-if="
												item.listing_attribute.listing_attributes_children
													.length
											"
										>
											<template
												v-for="(value, key) in item.listing_attribute
													.listing_attributes_children"
											>
												<b-form-input
													:placeholder="$t(value.name)"
													:key="key"
													v-if="value.listing_attributes_type.type == 'Textbox'"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													class="mt-10"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
												<b-dropdown no-flip
													:key="key"
													class="menu-dropdown mt-10"
													v-if="
														value.listing_attributes_type.type ==
															'Select option'
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
													<template v-slot:button-content>
														<span>
															{{
																dropdownChooseValue[`selectValue_${value.id}`]
															}}
															<IconChevronDown />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, key) in value.listing_pre_values"
														:key="key"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[`selectValue_${value.id}`] =
																val.value;
														"
														>{{ $t(val.value) }}</b-dropdown-item
													>
												</b-dropdown>
											</template>
										</template>
									</template>
								</b-form-group>
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Select option'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										<b-dropdown no-flip
											class="menu-dropdown"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `selectValue_${item.attr_id}`
													)
											}"
										>
											<template v-slot:button-content>
												<span>
													{{
														dropdownChooseValue[`selectValue_${item.attr_id}`]
													}}
													<IconChevronDown />
												</span>
											</template>
											<b-dropdown-item
												v-for="(value, k) in item.listing_attribute
													.listing_pre_values"
												:key="k"
												@click="
													listing.listingAttr.data[
														`selectValue_${item.attr_id}`
													] = value.id;
													dropdownChooseValue[`selectValue_${item.attr_id}`] =
														value.value;
												"
												>{{ $t(value.value) }}</b-dropdown-item
											>
										</b-dropdown>
									</template>
								</b-form-group>
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Number' && listing.listingAttr.data.radioValue_18 == 56
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										
										<masked-input
											type="text"
											class="form-control"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.name)"
										></masked-input>
										<template
											v-if="
												item.listing_attribute.listing_attributes_children
													.length
											"
										>
											<template
												v-for="(value, key) in item.listing_attribute
													.listing_attributes_children"
											>
												<b-form-input
													:placeholder="$t(value.name)"
													:key="key"
													v-if="value.listing_attributes_type.type == 'Textbox'"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													class="mt-10"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
												<masked-input
													class="form-control mt-10"
													:key="key"
													type="text"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.name)"
												></masked-input>
											</template>
										</template>
									</template>
								</b-form-group>
							</b-col>
						</template>
						<b-col
							cols="12"
							v-if="
								listing.mainCategory.key != '4' &&
									listing.mainCategory.idCategory != 4
							"
						>
							<b-form-group>
								<template v-slot:label>
									{{ $t('addListing.details.price') }}
									<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor)!important"/>
								</template>
								<b-tooltip
									custom-class="website-tool-tips"
									target="price-info"
									triggers="click"
								>
									{{$t('Please enter the actual product price Failure to do so will result in an offense under the Notification of the Central Committee on Prices of Goods and Services No 102 B E 2562')}}
								</b-tooltip>
								<masked-input
									type="text"
									class="form-control"
									v-model="listing.price"
									:class="{
										'input-error': validateErrors ? validateErrors.price : false
									}"
									:mask="numberAmountMask()"
									:placeholder="$t('addListing.details.price')"
								></masked-input>
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group
								:label="$t('addListing.details.productImages')"
								class="upload-div"
							>
								<Fileuploader
									name="files"
									:maxFiles="
										listing.mainCategory.key == 2 ||
										listing.mainCategory.key == 3
											? '10'
											: '6'
									"
									:class="{
										'input-error': validateErrors
											? validateErrors.imageError
											: false
									}"
									accept="jpg, png, jpeg"
									:hideFileUploader="hideFileUploader"
									:multiple="true"
									v-on:childToParent="getFile"
									:fileUploaded="arrImageUploaded"
									:theme="'thumbnails'"
									:changeInput="' '"
								/>
								<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Recommend picture size 1200x675 pixel')}}</p>
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_description)">
								<b-form-textarea
									:placeholder="$t(childCategories.field_name_description)"
									v-model="listing.description"
									class="product-detail"
									:class="{
										'input-error': validateErrors
											? validateErrors.description
											: false
									}"
									rows="3"
								></b-form-textarea>
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group :label="$t('addListing.details.keywords')" >
								<b-form-tags
									input-id="tags-validation"
									:input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
									separator=" ,;"
									remove-on-delete
									:tag-validator="tagValidator"
									v-model="listing.keywords"
									class="mb-2"
									tag-pills
									size="md"
									:placeholder="$t('addListing.details.keywordsPlaceholder')"
									isDuplicate="false"
								></b-form-tags>
								<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Please fill keywords relate with your listing for customer searching and found you listing')}}</p>
							</b-form-group>
						</b-col>
						<!-- Province / District -->
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_location)">
								<b-dropdown no-flip
									class="menu-dropdown"
									:class="{
										'input-error': validateErrors ? validateErrors.state : false
									}"
								>
									<template v-slot:button-content>
										{{
											listing.state
												? $t(listing.state.name)
												: $t('addListing.details.province')
										}}
										<IconChevronDown />
									</template>
									<b-dropdown-item
										v-for="(province, key) in arrListProvince"
										v-bind:key="`sub-category-${key}`"
										@click="handleProvinceChange(province)"
										>{{ $t(province.name) }}</b-dropdown-item
									>
								</b-dropdown>
								<b-dropdown no-flip
									class="menu-dropdown mt-10"
									:class="{
										'input-error': validateErrors
											? validateErrors.district
											: false
									}"
								>
									<template v-slot:button-content>
										{{
											listing.district
												? $t(listing.district.name)
												: $t('addListing.details.district')
										}}
										<IconChevronDown />
									</template>
									<b-dropdown-item
										v-for="(district, key) in arrListDistrict"
										v-bind:key="`sub-category-${key}`"
										@click="listing.district = district"
										>{{ $t(district.name) }}</b-dropdown-item
									>
								</b-dropdown>
							</b-form-group>
						</b-col>
						<b-col cols="12" class="contact-details">
							<b-form-group :label="$t('addListing.details.contactDetails')">
								<b-form-checkbox v-model="listing.takeContactFromDashboard">{{
									$t('addListing.details.takeFromDashboard')
								}}</b-form-checkbox>
							</b-form-group>
							<b-form-group>
								<b-form-input
									:placeholder="$t('user.email')"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.phoneAndEmail
											: false
									}"
									v-model="listing.email"
									:disabled="listing.takeContactFromDashboard"
								></b-form-input>
							</b-form-group>
							<b-form-group>
								<b-form-input
									type="number"
									:placeholder="$t('only numbers')"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.phoneAndEmail
											: false
									}"
									v-model="listing.phoneNumber"
									:disabled="listing.takeContactFromDashboard"
								></b-form-input>
							</b-form-group>
							<b-form-group>
								<div class="d-flex flex-row  no-gutters">
									<img src="/images/line.png" style="width: 35px;height:35px; margin-right: 10px;" :alt="('Affiliate trading', {affiliate: $root.affiliate})"/>
									<b-form-input
										:placeholder="$t('line')"
										class="input-search"
										v-model="listing.line_id"
										:disabled="listing.takeContactFromDashboard"
									></b-form-input>
								</div>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
				<b-row>
					<!-- Packages -->
					<b-modal
						id="package-model"
						class="package-model"
						title="Preview Listing"
						size="xl"
						scrollable
						hide-footer
						hide-header
						ref="package-model"
						center
						no-close-on-backdrop
						no-close-on-esc
						>
						<div class="package-model">
							<Packages
								v-if="arrUserPayment || $route.name === 'AddListing'"
								@childToParent="getSelectedPackages"
								:userPayment="arrUserPayment"
								:website="listing.website"
							/>
							<div class="footer " >
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button class="cancel-button ml-3 mr-2" 
								style="width:100px;border: 1px solid var(--projectPrimaryColor)!important;background-color: white!important;color: var(--projectPrimaryColor) !important;"  variant="danger" @click="toggleAdsImag()">{{$t('addListing.details.skipPackage')}}</b-button>
								<b-button class="okay-button success-button mr-5" style="width:100px;"  variant="success" 
								@click="addPackage()" :disabled="disabledPackageButton">{{$t('addListing.details.ok')}}</b-button>
								<!-- Button with custom close trigger value -->
							</div>
						</div>
					</b-modal>
					<b-modal
						id="image-ads-model"
						class="image-ads-model"
						hide-footer
						hide-header
						ref="image-ads-model"
						centered
						size="lg"
						no-close-on-backdrop
						no-close-on-esc
						>
							
							<div style="position: relative;">
								<img class="mobile-image" :src="'/images/popup/ads-image-'+selectedLanguage+'.png'"/>
								<img :src="'/images/popup/upgrade.png'"
								style="position: absolute;width: 35%;
								right: 0;top:34px;cursor: pointer;" @click="openPakcageDialog()"/>
								
								<img class="no-mobile-image" :src="'/images/popup/no-'+selectedLanguage+'.png'" @click="addPackage(true)"/>
								<img class="yes-mobile-image" :src="'/images/popup/yes-'+selectedLanguage+'.png'"   @click="openPakcageDialog()"  />
							</div>
					</b-modal>
					<b-col cols="12" class="button-func">
						<div class="text">
							{{ $t('addListing.details.clickPostToAccept') }}
							<p>{{ $t('addListing.details.termsCondition') }}</p>
						</div>
						<b-button
							type="button"
							class="btn-submit-search"
							v-on:click="openPakcageDialog()"
							:disabled="disabled"
							>{{ $t('addListing.details.post') }}</b-button
						>
					</b-col>
				</b-row>
				<b-modal
					id="listing-preview-dialog-first"
					centered
					hide-footer
					hide-header
					size="lg"
					no-close-on-backdrop
				>
					<b-row class="button-second-step">
						<b-col cols="12" class="text-center step-info">
							<IconClipboardList class="icon-clipboard" />
							<h4>{{ $t('addListing.details.listingUnderReview') }}</h4>
							<!-- <p style="margin-bottom:0;">{{ $t('addListing.details.listingPreviewText') }}</p> -->
							<p style="margin-bottom:0;">
								{{$t('please click')}}
								<b>{{$t('Confirm the announcement')}}</b> {{$t('to complete the posting process')}}
							</p>
							<p>{{ $t('addListing.details.listingPreviewText1') }}</p>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-button
								class="btn-submit-search extra-background-color-button"
								@click="previousEditListing"
								>{{ $t('addListing.details.editProductButton') }}</b-button
							>
						</b-col>
						<b-col cols="12">
							<b-button
								type="submit"
								class="btn-submit-search extra-background-color-button"
								@click="openPreviewDialog();"
								id="previewListing"
								>{{ $t('addListing.details.previewButton') }}</b-button
							>
							<b-modal
								id="preview-model"
								class="listing-preview-dialog"
								title="Preview Listing"
								size="xl"
								scrollable
								hide-header
								no-close-on-backdrop
							>
								<ListingDetail :listingDetailsFront="arrListPreview" />
								<template v-slot:modal-footer="{ ok, cancel }">
									<div class="footer">
										<!-- Emulate built in modal footer ok and cancel button actions -->
										<b-button
											variant="success"
											id="accept"
											@click="
												ok();
											"
											>{{$t('OK')}}</b-button
										>
										<b-button
											variant="danger"
											id="cancel"
											@click="
												cancel();
											"
											>{{$t('Cancel')}}</b-button
										>
										<!-- Button with custom close trigger value -->
									</div>
								</template>
							</b-modal>
						</b-col>
						<b-col cols="12">
							<b-button v-on:click="skipAddListing" id="confirmAddListing" style="background-color:var(--projectPrimaryColor);border-color:var(--projectPrimaryColor);">{{
								$t('addListing.details.skipButton')
							}}</b-button>
						</b-col>
					</b-row>
				</b-modal>
			</template>
			<template v-if="secondStep">
				<b-row class="button-second-step">
					<b-col cols="12" class="text-center step-info">
						<IconLightClock class="icon-light-clock" />
						<p>{{ $t('addListing.details.reviewText') }}</p>
					</b-col>
					<b-col cols="12" class="button-div">
						<router-link id="home" :to="$i18nRoute({ name: '' })">
							<b-button type="button" class="btn-submit-search"
								>{{$t('back to home page')}}</b-button
							>
						</router-link>
					</b-col>
				</b-row>
			</template>
		</b-container>
		<template v-if="firstStep">
			<b-row class="box-order-func" v-bind:class="{ active: isActiveCategory }">
				<template v-for="(item, key) in categoriesOptions">
					<b-col v-bind:key="key" cols="6" class="box-func">
						<span
							@click="showCateChild(key + 1, item.id, item.name, item)"
							v-html="item.url_icon2"
						></span>
						<p>{{ $t(item.name) }}</p>
					</b-col>
				</template>
			</b-row>
			<b-row
				class="box-cate-child"
				v-bind:class="{ active: isActiveCateChild }"
			>
				<b-col cols="12">
					<ul>
						<li></li>
						<template>
							<li
								v-for="(item, key) in childCategories.listing_category_children"
								:key="key"
								@click="selectCateChild(item, key + 1)"
							>
								{{ $t(item.name) }}
							</li>
						</template>
					</ul>
				</b-col>
			</b-row>
			<div
				class="backdrop"
				v-bind:class="{
					active:
						isActiveBackDrop == isActiveCategory ||
						isActiveBackDrop == isActiveCateChild
				}"
				@click="hideBackdrop"
			></div>
		</template>
	</div>
</template>
<script>
import MaskedInput from 'vue-text-mask';
import { gmapApi } from 'vue2-google-maps';
import Fileuploader from '@/components/newFileuploader/index';
import Packages from '@/components/packages/Packages';

import ListingDetail from '@/components/listing/listingDetail/ListingDetail';
import EditListingDesktop from '@/components/listing/editListing/EditListingDesktop';
// Icons
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import IconChevronDown from '@/components/icons/IconChevronDown/index';
import IconClipboardList from '@/components/icons/IconClipboardList/index';
import IconLightClock from '@/components/icons/IconLightClock/index';

export default {
	extends: EditListingDesktop,

	components: {
		PencilIcon,
		// MagnifyIcon,
		CheckIcon,
		IconChevronDown,
		Fileuploader,
		IconClipboardList,
		IconLightClock,
		Packages,
		ListingDetail,
		MaskedInput
	},
	data() {
		return {
			isActiveCategory: false,
			isActiveCateChild: false,
			isActiveBackDrop: true
		};
	},
	mounted() {
		if(!this.$root.isAuthenticated){
			this.$root.signIn('add-listing');
		}
	},
	methods: {
		hideBackdrop() {
			this.isActiveCategory = false;
			this.isActiveCateChild = false;
			// this.hideFileUploader = false;
		},
		showCateChild(key, idCategory, name_cate, cateogryValue) {
			if(idCategory==2){
				window.location.href=cateogryValue.redirect_to+`/th/add-listing?siteUrl=${window.location.origin}&sitetitle=${this.$root.siteTitle}`;
			}
			this.categoryFirstChange = true;
			this.listing.mainCategory.key = key;
			this.listing.mainCategory.idCategory = idCategory;
			this.isActiveCategory = false;
			this.listing.mainCategory.name = name_cate;
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			this.validateInputDynamic = [];
			// this.hideFileUploader = false;
		},
		selectCateChild(item) {
			this.listing.subCategory = item;
			this.hideBackdrop();
		},
		changeRadioValue(ev, name) {
			this.listing.listingAttr.data[name] = ev;
			this.$forceUpdate();
		},
		openPreviewDialog(){
			this.previewAddListing();
			// this.hideFileUploader=true;
		}
	}
};
</script>
<style lang="scss">
@import 'editListingMobile.scss';
.mobile-image{
	width: 100%;
}
.yes-mobile-image{
    position: absolute;
    right: 50px;
    bottom: 18px;
    cursor: pointer;
    width: 35%;
}
.no-mobile-image{
    position: absolute;
    left: 30px;
    bottom: 22px;
    cursor: pointer;
    width: 35%;
}
</style>
